module.exports = __webpack_public_path__ + "assets/images/footer-logo.aeed638c.png";


//////////////////
// WEBPACK FOOTER
// ./imgs/footer-logo.png
// module id = 2
// module chunks = 0